// src/app/components/auth/login/login.component.ts

import { Component, OnInit } from "@angular/core";
import { ActivatedRoute }    from "@angular/router";
import { AuthService }       from "../../../services/auth/auth.service";
import { ThemeService }      from "../../../services/theme/theme.service";
import { LanguageService }   from "../../../services/language/language.service";
import { FrontendLoggerService } from "../../../services/frontend-logger.service";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    standalone: false
})
export class LoginComponent implements OnInit {
  isLoading    = false;
  errorMessage = "";
  private requestedReturnUrl = '/home';

  constructor(
    private readonly authService:   AuthService,
    private readonly route: ActivatedRoute,
    public themeService:   ThemeService,
    public languageService: LanguageService,
    private readonly frontendLogger: FrontendLoggerService
  ) {}

  ngOnInit(): void {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.requestedReturnUrl = this.getSafeReturnUrl(returnUrl);
  }

  private getSafeReturnUrl(returnUrl: string | null): string {
    const normalized = (returnUrl || '').trim();
    if (!normalized || normalized === '/') {
      return '/home';
    }

    if (normalized.startsWith('/login') || normalized.startsWith('/signup')) {
      return '/home';
    }

    return normalized.startsWith('/') ? normalized : `/${normalized}`;
  }

  login(): void {
    this.isLoading    = true;
    this.errorMessage = "";
    this.frontendLogger.info("[LoginComponent] Iniciando login...");
    this.authService.login(this.requestedReturnUrl).subscribe({
      next: () => {
        this.frontendLogger.info("[LoginComponent] loginWithRedirect lanzado");
        this.isLoading = false;
        // Ya no registrar login exitoso aquí, solo en AppComponent tras autenticación
      },
      error: (error) => {
        this.frontendLogger.error("[LoginComponent] Error durante el inicio de sesión", error);
        this.errorMessage =
          "Error al iniciar sesión. Por favor, inténtalo de nuevo.";
        this.isLoading = false;
        // Registrar intento de login fallido
        this.authService.registerLoginHistory(false);
      },
    });
  }

  signup(): void {
    this.isLoading    = true;
    this.errorMessage = "";

    this.authService.signup("/wizard").subscribe({
      next: () => {
        // Auth0 manejará la redirección
        this.isLoading = false;
      },
      error: (error) => {
        this.frontendLogger.error("Error durante el registro", error);
        this.errorMessage =
          "Error al registrarse. Por favor, inténtalo de nuevo.";
        this.isLoading = false;
      },
    });
  }

  translate(key: string): string {
    return this.languageService.translate(key);
  }
}
